import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import firebase from 'firebase'
import {
  BrowserRouter as Router,
} from 'react-router-dom'


const config = {
  apiKey: "AIzaSyCCbiWVQkPFztvpOy05bw6nBzKhL3xYR_8",
  authDomain: "just-is.firebaseapp.com",
  databaseURL: "https://just-is.firebaseio.com",
  projectId: "just-is",
  storageBucket: "just-is.appspot.com",
  messagingSenderId: "304460882935",
  appId: "1:304460882935:web:791005f100e16e1a4004f2"
};
firebase.initializeApp(config);


// const updates = {}

// ololo.forEach((value, i) => {
//   updates['Usernames/' + 'reserved' + i] = value
// })

// console.log(updates)

// firebase.database().ref().update(updates).
// then(() => console.log('updated'))

ReactDOM.render(
  <Router>
    <App />
  </Router>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js